// Centralized social media configuration for Pacific Key Management.
//
// Add ONLY verified official PKM profile URLs here. A network with an empty
// url is automatically hidden everywhere (footer, contact page) and omitted
// from JSON-LD `sameAs` — nothing renders until a real URL is provided.
//
// To add a future platform (e.g. YouTube), append an entry with the correct
// `key` (must match an icon in SocialLinks.jsx) and its official url.
export const SOCIAL_LINKS = [
    { key: "instagram", label: "Instagram", url: "https://www.instagram.com/pacifickeymanagement/" },
    { key: "facebook", label: "Facebook", url: "https://www.facebook.com/PacificKeyManagement" },
    { key: "linkedin", label: "LinkedIn", url: "" },
];

// Only entries with a real url are ever published.
export const PUBLISHED_SOCIAL = SOCIAL_LINKS.filter((s) => s.url && s.url.trim());

// Verified URLs for JSON-LD Organization/LocalBusiness `sameAs`.
export const SOCIAL_SAME_AS = PUBLISHED_SOCIAL.map((s) => s.url.trim());
